import { FilterWithMatchingTopicTypeIdOptions, GridTopicFieldRenderer } from '@app/shared/grid/grid-options';
import { Topic } from '@app/origami-api/utils/topic-utils';
import { CountriesModel } from '@app/pages/main/pages/startup-countries/models/countries.interfaces';
import { LayoutState } from '@app/shared/layout/layout';
import { LayoutTreeState } from '@app/shared/layout/layout-tree/layout-tree';
import { LayoutGridState } from '@app/shared/layout/layout-grid/layout-grid';
import { InvestigativeSiteServiceOptions } from '@app/origami-api/services/investigative-site.service';
import { LayoutCodingComponentState } from '@app/shared/layout/layout-coding/layout-coding.model';

export namespace BudgetsAndContractsModels {
  // BAC - BudgetsAndContracts
  import StateToolbarBtn = CountriesModel.StateToolbarBtn;
  import GetBudgetsOrContractsOptions = InvestigativeSiteServiceOptions.GetBudgetsOrContractsOptions;
  export const BudgetsAndContractsIcon = 'fa fa-usd';
  export interface UpdateLayoutEvent {
    onlyHeaderTabs?: boolean;
    onlyQueryParamAndData?: boolean;
    both?: boolean;
  }

  export enum BACLayoutViewType {
    BUDGETS_MAIN_VIEW = 1,
    CONTRACTS_MAIN_VIEW = 2,

    BUDGETS_SSU_SITE_VIEW = 3,
    CONTRACTS_SSU_SITE_VIEW = 4,
  }

  export interface BACColumnOptions {
    topicTypeRenderers: GridTopicFieldRenderer<any, any>[];
    forms?: FilterWithMatchingTopicTypeIdOptions;
  }

  export interface BACLayoutViewTypeOptions {
    prefix: string;
    viewType: BACLayoutViewType;
    baseTopicTypeName: string;
    baseTopicTypeId: number;
    skipDefaultRefresh: boolean;
    relatedEntity: {
      id: number;
      name?: string;
    };
    // [key: string]: any;
  }

  export interface BACLayoutActionsParams {
    icon?: string;
    text?: string;
    showWhen?: StateToolbarBtn;
    defaultHidden?: boolean;
    activeWhen?: StateToolbarBtn;
    defaultDisable?: boolean;
  }

  export interface BACCommonActionsParams {
    budgetOrContract: Topic;
    topicTypeId: number;
    relatedEntityId: number;
  }

  export interface BACCoddingOptions {
    likeCodding: boolean;
    topicTypeId: number;
    entity: Topic;
    relatedEntityId: number;
  }

  export interface BACViewerOptions {
    topicTypeId: number;
    entity: Topic;
    relatedEntityId: number;
  }

  export type BACActionsInput = LayoutState<
    LayoutTreeState<any, any>,
    LayoutGridState<GetBudgetsOrContractsOptions, Topic>,
    LayoutCodingComponentState<any>,
    any
  >;

  export interface BACActionResult {
    cancel: boolean;
    data: Topic;
  }

  export enum BudgetsAndContractsStatus {
    Draft = 1,
    UnderReview = 2,
    Revisions = 3,
    SentForSignature = 4,
    Finalized = 5,
  }

  export const BACStatusStrings = {
    [BudgetsAndContractsStatus.Draft]: 'Draft',
    [BudgetsAndContractsStatus.UnderReview]: 'Under Review',
    [BudgetsAndContractsStatus.Revisions]: 'Revisions',
    [BudgetsAndContractsStatus.SentForSignature]: 'Sent for Signature',
    [BudgetsAndContractsStatus.Finalized]: 'Finalized',
  };

  export const BACStatusDropdown = [
    {
      id: BudgetsAndContractsStatus.Draft,
      name: BACStatusStrings[BudgetsAndContractsStatus.Draft],
      value: BudgetsAndContractsStatus.Draft,
    },
    {
      id: BudgetsAndContractsStatus.UnderReview,
      name: BACStatusStrings[BudgetsAndContractsStatus.UnderReview],
      value: BudgetsAndContractsStatus.UnderReview,
    },
    {
      id: BudgetsAndContractsStatus.Revisions,
      name: BACStatusStrings[BudgetsAndContractsStatus.Revisions],
      value: BudgetsAndContractsStatus.Revisions,
    },
    {
      id: BudgetsAndContractsStatus.SentForSignature,
      name: BACStatusStrings[BudgetsAndContractsStatus.SentForSignature],
      value: BudgetsAndContractsStatus.SentForSignature,
    },
    {
      id: BudgetsAndContractsStatus.Finalized,
      name: BACStatusStrings[BudgetsAndContractsStatus.Finalized],
      value: BudgetsAndContractsStatus.Finalized,
    },
  ];
}
